import fetchGql from '@/utils/fetchGql'
import { isEn } from '@/utils/helpers'

const query = gql`
  query SinglepressreleaseItems($starts_with: String, $filter: JsonScalar) {
    SinglepressreleaseItems(starts_with: $starts_with, filter_query: $filter) {
      items {
        content {
          specRelease
          title
          lead
          body
          publishDate
          termsAndConditions {
            content
          }
          termsAndConditionsDecline {
            content
          }
        }
        full_slug
      }
    }
  }
`

const prevNextQuery = gql`
  query SinglepressreleaseItems($language: String, $slug: String, $perPage: Int, $filter: JsonScalar, $sortBy: String) {
    SinglepressreleaseItems(
      starts_with: $language
      by_slugs: $slug
      per_page: $perPage
      filter_query: $filter
      sort_by: $sortBy
    ) {
      items {
        content {
          specRelease
          body
          title
          lead
          publishDate
          termsAndConditions {
            content
          }
          termsAndConditionsDecline {
            content
          }
        }
        full_slug
      }
    }
  }
`

export const useFetchPress = () => {
  const fetchPress = (language: string, slug: string) => {
    const variables = {
      starts_with: `${isEn(language) ? '' : language + '/'}press-releases/${slug.replace(/lv\/|en\/|lt\/|et\//, '')}`,
      filter: { availableLanguages: { in_array: isEn(language) ? 'default' : language } }
    }

    return fetchGql(query, variables).then((response: any) => response.SinglepressreleaseItems.items)
  }

  return { fetchPress }
}

export const useFetchPaginationPress = () => {
  const fetchPaginationPress = (language: string, date: string, isFutureEvent: boolean) => {
    const filterFuture = { publishDate: { gt_date: date } }
    const filterPast = { publishDate: { lt_date: date } }
    const variables = {
      language: isEn(language) ? '' : `${language}/*`,
      perPage: 2,
      sortBy: isFutureEvent ? 'content.publishDate:asc' : 'content.publishDate:desc',
      filter: {
        ...(isFutureEvent ? filterFuture : filterPast),
        availableLanguages: { in_array: isEn(language) ? 'default' : language }
      }
    }

    return fetchGql(prevNextQuery, variables).then((response: any) => response.SinglepressreleaseItems.items)
  }

  return { fetchPaginationPress }
}
